
import React from 'react';
import { ChevronRight, Pause, Play, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { BotStatus } from '@/types/trader';
import { useTranslation } from 'react-i18next';

interface CardActionsProps {
  id: string;
  status: BotStatus;
  onViewDetails: (id: string) => void;
  onToggleStatus: (id: string, currentStatus: BotStatus) => void;
  onDelete: (id: string) => void;
}

export const CardActions: React.FC<CardActionsProps> = ({
  id,
  status,
  onViewDetails,
  onToggleStatus,
  onDelete
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex justify-between items-center">
      <Button 
        variant="ghost" 
        size="sm" 
        className="px-0 hover:bg-transparent hover:text-primary"
        onClick={() => onViewDetails(id)}
      >
        {t('view_details')}
        <ChevronRight size={16} className="ml-1" />
      </Button>
      
      {status === 'active' ? (
        <Button 
          size="sm" 
          variant="outline"
          onClick={() => onToggleStatus(id, status)}
        >
          <Pause size={16} className="mr-2" />
          {t('pause')}
        </Button>
      ) : (
        <div className="flex gap-2">
          <Button 
            size="sm" 
            variant="destructive" 
            onClick={() => onDelete(id)}
            aria-label={t('delete')}
          >
            <Trash2 size={16} />
          </Button>
          <Button 
            size="sm" 
            className="bg-primary hover:bg-primary/90"
            onClick={() => onToggleStatus(id, status)}
          >
            <Play size={16} className="mr-2" />
            {t('start')}
          </Button>
        </div>
      )}
    </div>
  );
};
